function DisplayDigits({ digits, text }) {
  return (
    <div className="mr-3">
      <div className="is-flex is-flex-direction-row">
        <div className="has-border-purple-2 mr-1 has-text-centered" style={{ width: "20px" }}>
          {/* <div style={{ width: "20px", textAlign: "center" }}> */}
          {digits.toString().length === 1 ? 0 : digits.toString().charAt(0)}
          {/* </div> */}
        </div>
        <div className="has-border-purple-2 has-text-centered" style={{ width: "20px" }}>
          {/* <div style={{ width: "20px", textAlign: "center" }}> */}
          {digits.toString().length === 2 ? digits.toString().charAt(1) : digits.toString()}
          {/* </div> */}
        </div>
      </div>
      <div className="is-size-7 has-text-centered">{text}</div>
    </div>
  );
}

export default DisplayDigits;
